{% block ecocode_trustpilot_connect %}
        <div slot="content">
            <sw-loader v-if="isLoading"></sw-loader>
            <template v-else>
                <h2>{{ $tc("ecocode-trustpilot.connect.modalHeadline") }}</h2>
                <div>{{ $tc("ecocode-trustpilot.connect.modalBody") }}</div>
                <br>
                <sw-button class="mt-external-link" :disabled="false" variant="primary" size="large" :square="false" :block="false" :link="connectLink" :isLoading="false">
                    {{ $tc("ecocode-trustpilot.connect.buttonText") }}
                </sw-button>
            </template>
        </div>
{% endblock %}
